/**
 * @generated SignedSource<<ea4c694fef420fd69e4b5f246c04e8f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderHistoryTable_Refetch$variables = {
  id: string;
};
export type OrderHistoryTable_Refetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"orderHistoryTable_OrderHistoriesFragment">;
};
export type OrderHistoryTable_Refetch = {
  response: OrderHistoryTable_Refetch$data;
  variables: OrderHistoryTable_Refetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceNumber",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  (v2/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentToInvoiceEmail",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentByUserId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "sentBy",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrderHistoryTable_Refetch",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "orderHistoryTable_OrderHistoriesFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrderHistoryTable_Refetch",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrderHistory",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "event",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "kind",
                        "storageKey": null
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isHistoryEvent"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "when",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "invoiceId",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "type": "InvoiceSentEvent",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "previousInvoiceEmail",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "newInvoiceEmail",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "correctedByUserId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "correctedBy",
                            "plural": false,
                            "selections": (v4/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "InvoiceEmailCorrectedEvent",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "type": "ClaimEmailResentEvent",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "type": "InvoiceResentEvent",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "reason",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "closedByUserId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "closedBy",
                            "plural": false,
                            "selections": (v4/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "OrderClosedByAdminEvent",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Order",
            "abstractKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "45e70f8cf944a7f103eb11d116e43333",
    "id": null,
    "metadata": {},
    "name": "OrderHistoryTable_Refetch",
    "operationKind": "query",
    "text": "query OrderHistoryTable_Refetch(\n  $id: ID!\n) {\n  ...orderHistoryTable_OrderHistoriesFragment\n}\n\nfragment orderHistoryEvent_OrderHistoryFragment on HistoryEvent {\n  __isHistoryEvent: __typename\n  kind\n  when\n  ... on InvoiceSentEvent {\n    invoiceId\n    invoiceNumber\n  }\n  ... on InvoiceEmailCorrectedEvent {\n    previousInvoiceEmail\n    newInvoiceEmail\n    correctedByUserId\n    correctedBy {\n      name\n      email\n      id\n    }\n  }\n  ... on ClaimEmailResentEvent {\n    sentToInvoiceEmail\n    sentByUserId\n    sentBy {\n      name\n      email\n      id\n    }\n  }\n  ... on InvoiceResentEvent {\n    invoiceNumber\n    sentToInvoiceEmail\n    sentByUserId\n    sentBy {\n      name\n      email\n      id\n    }\n  }\n  ... on OrderClosedByAdminEvent {\n    reason\n    closedByUserId\n    closedBy {\n      name\n      email\n      id\n    }\n  }\n}\n\nfragment orderHistoryTable_OrderHistoriesFragment on Query {\n  node(id: $id) {\n    __typename\n    ... on Order {\n      history {\n        ...orderHistoryTable_OrderHistoryFragment\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment orderHistoryTable_OrderHistoryFragment on OrderHistory {\n  id\n  createdAt\n  status\n  event {\n    __typename\n    kind\n    ...orderHistoryEvent_OrderHistoryFragment\n  }\n}\n"
  }
};
})();

(node as any).hash = "2a9b474bfd102eee93c097343b92e226";

export default node;
